(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/date-time-picker.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/date-time-picker.js');
"use strict";


const {
  DateInput,
  TimeInput
} = svs.ui.reactFormInputs;
const {
  DATE,
  TIME
} = svs.tickets_giftshop.constants.names;
const {
  DATE_AND_TIME
} = svs.tickets_giftshop.constants.dateSelectorKey;
const DateTimePicker = _ref => {
  let {
    date,
    time,
    isHidden = false,
    onInputChange,
    minDate = svs.utils.date.SimpleDate(new Date()),
    maxDate = svs.utils.date.SimpleDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1)))
  } = _ref;
  const handleDateChange = e => {
    onInputChange({
      target: {
        value: {
          date: e.target.value,
          dateSelectorUsed: DATE_AND_TIME
        },
        name: DATE
      }
    });
  };
  const handleTimeChange = e => {
    onInputChange({
      target: {
        value: {
          time: e.target.value,
          dateSelectorUsed: DATE_AND_TIME
        },
        name: TIME
      }
    });
  };
  return React.createElement("div", {
    className: "g-date-input gutter-sm-2 ".concat(isHidden ? 'tg-date-time-hidden' : '')
  }, React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "col-sm-6 col-xs-12"
  }, React.createElement(DateInput, {
    max: maxDate,
    min: minDate,
    name: DATE,
    onChange: handleDateChange,
    value: date
  })), React.createElement("div", {
    className: "col-sm-6 col-xs-12"
  }, React.createElement(TimeInput, {
    name: TIME,
    onChange: handleTimeChange,
    value: time
  }))));
};
svs.tickets_giftshop.gift.giftform.date_selector.components.DateTimePicker = DateTimePicker;

 })(window);